import { priceWithDiscount } from '../utils/money';
import BaseSelector from './base';

export default class VariantData extends BaseSelector {
  prefix = 'variant-data';
  dataSelector = '.js-variant-data';

  getMaxSubscriptionDiscount = () => Math.max(
    ...Array.from(document.querySelectorAll(this.dataSelector), (element) => +element.dataset.subscriptionDiscount)
  );

  normalizedData = (dataset) => {
    const price = parseFloat(dataset.price);
    const otpDiscount = +dataset.otpDiscount;
    const subscriptionDiscount = +dataset.subscriptionDiscount;
    const otpPrice = Math.round(priceWithDiscount(price, otpDiscount));
    const subscriptionPrice = Math.round(priceWithDiscount(price, subscriptionDiscount));
    const servings = parseInt(dataset.servings || 0);
    const subscriptionServingPrice = subscriptionPrice / servings;
    const otpServingPrice = otpPrice / servings;

    return ({
      ...dataset,
      ...dataset.subscriptionId ? { subscriptionId: parseInt(dataset.subscriptionId) } : {},
      ...dataset.productOutOfStock ? { productOutOfStock: JSON.parse(dataset.productOutOfStock) } : {},
      ...dataset.disableFreeShipping ? { disableFreeShipping: JSON.parse(dataset.disableFreeShipping) } : {},
      price,
      otpPrice,
      servings,
      subscriptionPrice,
      otpServingPrice,
      subscriptionDiscount,
      subscriptionServingPrice,
      productId: parseInt(dataset.productId),
      variantId: parseInt(dataset.variantId),
      sellingPlan: parseInt(dataset.sellingPlan)
    });
  };
}
